import React, { useEffect, useState } from "react";
import IserbaGame1ClickPuzzle from "./beforeDriving/Game1ClickPuzzle";
import IserbaGame1Transition from "./beforeDriving/Game1ValidationTransition";
import Game1ValidationScreen from "./beforeDriving/Game1ValidationScreen";
import IserbaAvatarViewer from "../../../../onboarding/iserba/IserbaAvatarViewer";
import IserbaGame1ClickPuzzle2 from "./beforeDriving/Game1ClickPuzzle2";
import CumulatedScore from "components/quiz/CumulatedScore";

const IserbaGame1Wrapper = ({
	quiz,
	question,
	onAnswer,
	quizResults,
	setQuizResults,
	handleNext,
}) => {
	const [step, setStep] = useState("puzzle-parking"); // 'puzzle-parking' -> 'puzzle-in-car' -> 'transition' -> 'evaluation'
	const [isPuzzleCorrect, setIsPuzzleCorrect] = useState({
		scene_1_correct: false,
		scene_1_errors: [],
		scene_2_correct: false,
		scene_2_errors: [],
	});

	useEffect(() => {
		setQuizResults((prev) => ({
			...prev,
			score: 12,
		}));
	}, []);

	const storedPlayer = localStorage.getItem("player");
	let player = storedPlayer ? JSON.parse(storedPlayer) : null;

	const handlePuzzle1Completion = (result) => {
		setIsPuzzleCorrect((prev) => ({
			...prev,
			...result,
		}));
		setStep("puzzle-in-car");
	};

	const handlePuzzle2Completion = (result) => {
		setIsPuzzleCorrect((prev) => ({
			...prev,
			...result,
		}));
		setStep("transition");
	};

	const handleTransitionEnd = () => {
		setStep("evaluation");
	};

	const handleRetry = () => {
		setQuizResults((prev) => ({
			...prev,
			score: prev.score - 1,
		}));
		if (!isPuzzleCorrect.scene_1_correct) setStep("puzzle-parking");
		else setStep("puzzle-in-car");
	};

	const onSubmitAndNext = () => {
		onAnswer({ value: isPuzzleCorrect });
		handleNext();
	};

	const getHeaderText = () => {
		switch (step) {
			case "puzzle-parking":
				return question.text;
			case "puzzle-in-car":
				return question.text;
			case "transition":
				return "Démarrez la voiture en cliquant sur la clé...";
			case "evaluation":
				if (isPuzzleCorrect.scene_1_correct && isPuzzleCorrect.scene_2_correct)
					return "Félicitations ! Vous avez corrigé tous les problèmes.";
				return "Oops ! Un accident s'est produit. Essayez encore";
			default:
				return "...";
		}
	};

	return (
		<div className="relative flex flex-col items-center h-full mt-4">
			<div className="px-4 flex flex-1 justify-between items-end gap-2">
				<div className="flex flex-col text-white">
					<IserbaAvatarViewer player={player} />
					<h3 className="text-sm text-gray-700 py-2 px-4 shadow-md mb-2 bg-white rounded-full">
						{getHeaderText()}
					</h3>
				</div>

				{quiz?.config?.show_cumulated_score && (
					<div className="flex py-2 px-1">
						<CumulatedScore quizId={quiz.id} quizResults={quizResults} />
					</div>
				)}
			</div>

			<div className="flex-[3] flex justify-center items-start">
				{step === "puzzle-parking" && (
					<IserbaGame1ClickPuzzle
						question={question}
						onAnswer={handlePuzzle1Completion}
					/>
				)}

				{step === "puzzle-in-car" && (
					<IserbaGame1ClickPuzzle2
						question={question}
						onAnswer={handlePuzzle2Completion}
					/>
				)}

				{step === "transition" && (
					<IserbaGame1Transition handleTransitionEnd={handleTransitionEnd} />
				)}
				{step === "evaluation" && (
					<Game1ValidationScreen
						isPuzzleCorrect={isPuzzleCorrect}
						onRetry={handleRetry}
						onNext={onSubmitAndNext}
					/>
				)}
			</div>
		</div>
	);
};

export default IserbaGame1Wrapper;
